const NONE = {
  class: "",
  props: {
    animate: {},
    transition: {},
  },
};

export const MOTION = {
  null: NONE,
  none: NONE,

  "slide-up": {
    props: {
      initial: { opacity: 0, transform: "translateY(20%)" },
      animate: { opacity: 1, transform: "translateY(0)" },
      transition: {
        duration: 0.5,
        ease: [0.17, 0.55, 0.55, 1],
      },
    },
  },

  expand: {
    props: {
      initial: { opacity: 0, height: 0 },
      animate: { opacity: 1, height: "auto" },
      exit: { opacity: 0, height: 0 },
      transition: {
        duration: 0.3,
        ease: [0.17, 0.55, 0.55, 1],
      },
    },
  },

  "splash-in": {
    props: {
      animate: { opacity: 1, scale: 1 },
      initial: { opacity: 0, scale: 1.05 },
      transition: {
        duration: 0.4,
        ease: [0.17, 0.55, 0.55, 1],
      },
    },
  },

  "fade-in": {
    props: {
      animate: { opacity: 1 },
      initial: { opacity: 0 },
      transition: {
        duration: 0.5,
        ease: [0.17, 0.55, 0.55, 1],
      },
    },
  },
} as const;
